<script>
    export default {
        props: {
            data: Object,
            pushData: Function,
            spliceData: Function,
        },
        computed: {
            filters() {return this.$store.getters.FILTERS_NO_CHILD(this.data.asset_type_id)},
        },
        methods: {
            async changeData(event, id) {
                const state = event.target.checked;
                if (state === true) {
                    this.pushData(id, 'items');
                }
                else {
                    this.spliceData(id, 'items')
                }
            }
        }
    }
</script>

<template>
    <div class="left_filter_list">
        <div
            v-for="(filtersValue, filtersIndex) in filters" :key="filtersIndex"
            class="left_filter_container"
        >
            <div class="left_filter_header">
                <label>{{ filtersValue['name'] }}</label>
            </div>
            <div class="left_filter_body">
                <label
                    v-for="(filterItemValue, filterItemIndex) in filtersValue['filter_items']"
                    :key="filterItemIndex"
                    style="margin-top: 2px;"
                >
                    <input 
                        type="checkbox"
                        :checked="data['items'].includes(filterItemValue['id'])"
                        @change="changeData($event, filterItemValue['id'])"
                    >
                    {{ filterItemValue['name'] }}
                </label>
            </div>
        </div>
    </div>
</template>